import { PLACEMENT_DELIMETER } from "./constants";
import type { Placement } from "./types";
import type {
  Alignment,
  Position as FlyoutPosition,
  Side,
} from "../flyout/types";

export const getOppositeSide = (side: Side): Side => {
  switch (side) {
    case "top":
      return "bottom";

    case "right":
      return "left";

    case "bottom":
      return "top";

    case "left":
      return "right";

    default: {
      const remainingSide: never = side;

      return remainingSide;
    }
  }
};

export const mapTooltipPlacementToFlyoutPosition = (
  placement: Placement
): FlyoutPosition => {
  switch (placement) {
    case "top-center":
      return "top";

    case "top-left":
      return "top-start";

    case "top-right":
      return "top-end";

    case "right-center":
      return "right";

    case "right-top":
      return "right-start";

    case "right-bottom":
      return "right-end";

    case "bottom-center":
      return "bottom";

    case "bottom-left":
      return "bottom-start";

    case "bottom-right":
      return "bottom-end";

    case "left-center":
      return "left";

    case "left-top":
      return "left-start";

    case "left-bottom":
      return "left-end";

    default:
      throw new Error();
  }
};

/**
 * Разделяет Position на Side и Alignment
 */
export const splitPosition = (position: FlyoutPosition): [Side, Alignment] =>
  position.split(PLACEMENT_DELIMETER) as [Side, Alignment];

/**
 * Генерирует все позиции для расположения флайаута
 * Первыми идут переданная пользователем и противоположная ей, а затем остальные возможные
 */
export const getFlyoutPositionsOrder = (position: FlyoutPosition) => {
  const defaultSides: Side[] = ["left", "right", "top", "bottom"];

  const [side, align] = splitPosition(position);

  const oppositeSide = getOppositeSide(side);
  const oppositeAlign = align ? (`-${align}` as const) : "";

  const oppositePosition: FlyoutPosition = `${oppositeSide}${oppositeAlign}`;

  const remainingSides = defaultSides.filter(
    (defaultSide) => ![side, oppositeSide].includes(defaultSide)
  );

  const flyoutPositions: FlyoutPosition[] = [position, oppositePosition].concat(
    remainingSides
  );

  return flyoutPositions;
};
